import { render, staticRenderFns } from "./footerFixNav.vue?vue&type=template&id=712c689d&scoped=true&"
var script = {}
import style0 from "./footerFixNav.vue?vue&type=style&index=0&id=712c689d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "712c689d",
  null
  
)

export default component.exports